import { Text } from '@smartproxy/decoro/v2/text';

import { cn } from '@/lib/utils';

import { mutualLinkStyle } from '@/blocks/Footer';

import {
  FooterPopupImageLink,
  FooterPopupImageLinkBlock,
} from './FooterPopupImageLink';

type FooterContact = {
  title: string;
  links: FooterPopupImageLinkBlock[];
};

export type FooterContactsProps = {
  contacts: FooterContact[];
  classNames?: {
    container?: string;
    link?: string;
  };
};

const FooterContacts = ({ contacts, classNames }: FooterContactsProps) => {
  return contacts.map((contact, index) => {
    // in the unlikely scenario we will go with a mix of text/img variants,
    // if at least one link entry contains text, the entire section will be rendered as a list
    const shouldRenderAsList = contact.links.find((link) => !!link.link?.text);

    return (
      <div
        key={index}
        className={cn('flex flex-col', classNames?.container ?? 'gap-6')}
      >
        <Text
          variant='label'
          skin='secondary'
          className='text-neutral-400'
          weight='bold'
        >
          {contact.title}
        </Text>
        <div
          className={cn(
            mutualLinkStyle,
            'max-w-max',
            classNames?.link ?? 'gap-6',
            shouldRenderAsList
              ? 'flex flex-col flex-wrap gap-x-4 gap-y-3'
              : 'flex flex-row flex-wrap items-center'
          )}
        >
          {contact.links.map((link, index) => (
            <FooterPopupImageLink
              key={index}
              block={link}
              inner={{
                link: {
                  variant: 'text',
                  slim: true,
                  'data-tracker-context': `${index}`,
                  classNames: {
                    root: mutualLinkStyle,
                  },
                },
                popup: {
                  showArrow: true,
                  position: 'right',
                  classNames: {
                    childrenWrapper: 'h-[7.5rem] w-[7.5rem] p-2.5 border-none',
                  },
                },
                image: {
                  classNames: {
                    image: 'w-auto h-6',
                  },
                },
              }}
            />
          ))}
        </div>
      </div>
    );
  });
};

export default FooterContacts;
